import CoursePlayer from './src/main';

/* istanbul ignore next */
CoursePlayer.install = function(Vue) {
  Vue.component(CoursePlayer.name, CoursePlayer);
};

export default CoursePlayer;
